import "./assets/styles/main.css";
import ElementPlus from 'element-plus'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import 'element-plus/theme-chalk/index.css';
import { createApp } from 'vue'

// 引入组件
import App from './App'
// 引入资源
import router from './router'

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

// 创建app
const app = createApp(App)

// 注册Icon组件

// 注入路由
app.use(router)
app.use(ElementPlus,{locale})
app.use(VueViewer, {
    defaultOptions: {
        'inline': true, // 启用 inline 模式
        'button': true, // 显示右上角关闭按钮
        'navbar': true, // 显示缩略图导航
        'title': true, // 显示当前图片的标题
        'toolbar': true, // 显示工具栏
        'tooltip': true, // 显示缩放百分比
        'movable': true, // 图片是否可移动
        'zoomable': true, // 图片是否可缩放
        'rotatable': true, // 图片是否可旋转
        'scalable': true, // 图片是否可翻转
        'transition': true, // 使用 CSS3 过度
        'fullscreen': true, // 播放时是否全屏
        'keyboard': true, // 是否支持键盘
        // 'url': 'data-source', // 设置大图片的 url
        'zIndex': 9999
    }
  })
// 挂载实例
app.mount('#app')





